<!-- Mobile sidebar backdrop -->
<div
  [ngClass]="mobileMenuOpen ? 'block' : 'hidden'"
  class="fixed inset-0 bg-black/80 z-40"
  (click)="mobileMenuOpen = false"
></div>

<!-- Mobile sidebar drawer -->
<div
  class="fixed inset-y-0 ltr:left-0 rtl:right-0 w-72 bg-[#061430] z-40 transform transition duration-200 ease-in-out overflow-y-auto p-6"
  [ngClass]="mobileMenuOpen ? 'translate-x-0' : 'ltr:-translate-x-full rtl:translate-x-full'"
>
  <!-- Close + Logo -->
  <div class="flex items-center justify-between mb-8">
    <a routerLink="/" (click)="mobileMenuOpen = false">
      <img src="assets/images/logo_white.svg" alt="Uptal" width="100" height="40">
    </a>
    <button (click)="mobileMenuOpen = false" class="text-white">
      <app-icon name="tabler:x" [size]="24"/>
    </button>
  </div>

  <!-- Nav links -->
  <nav class="flex flex-col gap-4 text-white">
    <a routerLink="/recruiter-program" fragment="services" class="py-2" (click)="mobileMenuOpen = false">
      {{ 'recruiterProgram.header.features' | translate }}
    </a>
    <a routerLink="/recruiter-program" fragment="advanced-features" class="py-2" (click)="mobileMenuOpen = false">
      {{ 'recruiterProgram.header.solutions' | translate }}
    </a>
    <a routerLink="/recruiter-program" fragment="why-us" class="py-2" (click)="mobileMenuOpen = false">
      {{ 'recruiterProgram.header.whyUs' | translate }}
    </a>
  </nav>

  <!-- Language toggle -->
  <button class="mt-6 text-white flex items-center gap-2" (click)="switchLanguage()">
    <app-icon name="language" size="16"/>
    {{ langNames[currentLang] }}
  </button>
</div>

<!-- Header bar -->
<header class="py-4 flex justify-between items-center">
  <div class="flex items-center">
    <a routerLink="/" class="header-logo">
      <img src="assets/images/logo_white.svg" alt="Uptal" width="100" height="40">
    </a>

    <!-- Desktop nav -->
    <nav class="hidden lg:flex items-center gap-2 text-white ms-8">
      <a routerLink="/recruiter-program" fragment="services" class="py-2" (click)="mobileMenuOpen = false">
        {{ 'recruiterProgram.header.features' | translate }}
      </a>
      <a routerLink="/recruiter-program" fragment="advanced-features" class="px-4 py-2" (click)="mobileMenuOpen = false">
        {{ 'recruiterProgram.header.solutions' | translate }}
      </a>
      <a routerLink="/recruiter-program" fragment="why-us">
        {{ 'recruiterProgram.header.whyUs' | translate }}
      </a>
    </nav>

    <button class="hidden lg:flex px-4 text-white items-center gap-2" (click)="switchLanguage()">
      <app-icon name="language" size="16"/>
      {{ langNames[currentLang] }}
    </button>
  </div>

  <!-- Hamburger (mobile only) -->
  <button class="lg:hidden text-white" (click)="mobileMenuOpen = true">
    <app-icon name="tabler:menu-2" [size]="28"/>
  </button>

  <a [href]="getSignupUrl()" class="hidden lg:block rounded-full px-4 py-2 bg-primary text-white">
    {{ 'recruiterProgram.header.registerNow' | translate }}
  </a>
</header>
